module.exports = __webpack_public_path__ + "static/media/complete.6d90bfe7.svg";